
import { Button, Popup } from 'devextreme-react';
import { Column, FilterRow, Item, Summary, Toolbar, ToolbarItem } from 'devextreme-react/data-grid';
import { PageSize } from 'devextreme-react/diagram';
import Cookies from 'js-cookie';
import moment from 'moment';
import React, { useEffect, useRef, useState } from 'react';
import { toast } from 'react-toastify';
import { Card } from 'reactstrap';
import Swal from 'sweetalert2/dist/sweetalert2.js';
import 'sweetalert2/dist/sweetalert2.min.css';
import 'sweetalert2/src/sweetalert2.scss';
import { useAuth } from '../../auth';
import Breadcrumb from '../../components/common/breadcrumb';
import DatagridCustom from '../../components/common/datagrid/custom-datagrid';
import api from '../../services/api-configuration';
import { ButtonOnExporting } from '../../utils/DataGridExporter';
import useFormatMessage from '../../utils/useFormatMessage';
import DamageReportForm from './components/DamageReportForm';

const HasarBildirimi = () => {
    const { hasRole } = useAuth(9);
    const dataGridRef = useRef(null)
    const [dataSource, setDataSource] = useState([]);
    const notifyError = (message) => toast.error(`${message}`);
    const { t } = useFormatMessage()
    const pagesize = 10;
    const [visible, setVisible] = useState(false);

    const getAllDamegeReport = async () => {
        if (dataGridRef?.current?.instance) dataGridRef.current.instance.beginCustomLoading(`${t("Yükleniyor")}...`);
        try {
            const response = await api.post('/damage/getAll');
            if (dataGridRef?.current?.instance) await dataGridRef.current.instance.endCustomLoading();
            setDataSource(response.data || []);
        } catch (error) {
            notifyError(error?.response?.data?.message || t("Hasar bildirimleri alınırken bir hata oluştu"));
            console.error("Tüm hasar bildirimleri getirilemedi.");
        }
    }

    useEffect(() => {
        getAllDamegeReport();
        // eslint-disable-next-line
    }, []);

    const token = 'Bearer ' + Cookies.get('token');
    const imagePath = 'https://app.uklojistik.com/minio';

    async function loadImage(path, description) {
        try {
            const response = await fetch(imagePath + path, {
                headers: {
                    'Authorization': token,
                }
            });

            if (!response.ok) {
                throw new Error('Image fetch failed');
            }

            const blob = await response.blob();
            const imageUrl = URL.createObjectURL(blob);

            // Swal içinde resmi göster
            setTimeout(() => {
                Swal.fire({
                    title: '',
                    text: description || "",
                    imageUrl: imageUrl,
                    imageWidth: 450,
                    imageAlt: 'hasar image',
                    showCancelButton: true, // Kapat butonunu göster
                    cancelButtonText: 'Kapat', // Kapat butonunun metni
                    showConfirmButton: false, // Tamam butonunu gizle
                });
            }, 300);

        } catch (error) {
            let errorMessage = error.response?.data?.error || "";
            toast.error(t('Resim yüklenirken hata oluştu') + ":" + errorMessage);
            console.error('Image load error:', error);
        }
    }
    const handleAddData = async (data) => {
        let body = {
            "damage_date": moment(data.damage_date).format("YYYY-MM-DD HH:mm:ss"),
            "chassis_no": data.chassis_no,
            "damage_region": data.damage_region,
            "reporter_id": parseInt(Buffer.from(localStorage.getItem("employee_id"), 'base64').toString('ascii')),
            "responsible": data.responsible,
            "description": data.description
        }
        const image = data.image || null;

        const formData = new FormData();
        formData.append("data", JSON.stringify(body));
        if (image) formData.append("image", image);


        try {

            const response = await api.post('/damage/add', formData, {
                headers: {
                    'Content-Type': 'multipart/form-data'
                }
            });
            toast.success("Hasar bildirimi başarılı")

        } catch (error) {
            toast.error("BAŞARIZ: " + t(error.response.data.error))
        } finally {
            getAllDamegeReport();
        }

    }

    return (
        <>
            <Breadcrumb current={t("Hasar Bildirimi")} />
            <Card className='p-4'>
                <DatagridCustom
                    dataSource={dataSource}
                    reff={dataGridRef}

                >
                    <PageSize defaultPageSize={pagesize} />

                    <FilterRow visible={true} />
                    <Column dataField="damage_date"
                        // format={{
                        //     type: "date",
                        //     formatter: (date) => {
                        //         return new Intl.DateTimeFormat('en', {
                        //             month: 'long', // Uzun ay isimleri
                        //             day: 'numeric',
                        //             year: 'numeric'
                        //         }).format(date);
                        //     }
                        // }}
                        caption={t("Tarih")} dataType={"datetime"} alignment='center' format={"dd/MM/yyyy HH:mm"} sortIndex={0} sortOrder={"desc"} width={"200px"} />
                    <Column caption={t("Şase")} dataField="chassis_no" alignment='center' />
                    <Column dataField="description" caption={t("Hasar Açıklama")} alignment='center'>
                    </Column>
                    <Column dataField="damage_region" caption={t("Bölge")} alignment='center' />
                    <Column dataField="reporter_name" caption={t("Bildiren Kişi")} alignment='center' />
                    <Column dataField="responsible" caption={t("Hasar Sorumlusu")} alignment='center' />
                    <Column dataField="image_path" caption={t("Hasar Görseli")} alignment='center' cellRender={(e) => {
                        if (e.data.image_path === "" || e.data.image_path === null || e.data.image_path?.length < 2) return null;
                        return <Button className='p-0 px- 3' onClick={() => loadImage(e.data.image_path, e.data.description)}>{t("Göster")}</Button>

                    }} />
                    <Summary>
                        <ToolbarItem
                            column="chassis_no"
                            summaryType="count"
                            customizeText={(e) => `${t("Toplam")}: ${e.value}`}
                        />
                    </Summary>
                    <Toolbar >
                        <Item>
                            <Button
                                disabled={!hasRole("hasar_yonetimi_write")}
                                onClick={
                                    () => setVisible(true)
                                }>
                                Ekle
                            </Button>
                        </Item>
                        <Item >
                            <Button onClick={
                                () => getAllDamegeReport()
                            }>
                                <i className='fa fa-refresh'></i>
                            </Button>
                        </Item>
                        <Item>
                            <Button
                                style={{ backgroundColor: "#05C851", color: "white" }}
                                onClick={(e) => ButtonOnExporting(e, dataGridRef, `Hasar Listesi -  ${moment(new Date()).format("DD/MM/YYYY")}`, "Sayafa-1")

                                }>
                                <i className='fa fa-file-excel-o'></i>
                            </Button>
                        </Item>
                    </Toolbar>
                </DatagridCustom>
            </Card>

            <Popup
                visible={visible}
                width={"50%"}
                title='Hasar Bildirimi Ekle'
                height={"auto"}
                onHiding={() => setVisible(false)}
            >
                <DamageReportForm
                    onClose={() => setVisible(false)}
                    onSubmit={async (formData) => {
                        // Form verilerini işleme ve API'ye gönderme
                        try {
                            // API çağrısı yapılabilir
                            await handleAddData(formData);
                            setVisible(false);
                        } catch (error) {
                            notifyError(error.response?.data?.message || 'Bir hata oluştu');
                        }
                    }}
                />

            </Popup>


        </>
    )
}

export default HasarBildirimi

